import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Box, HStack, Icon, ShimmerText, Text } from '@betterment/samba-react';
import { formatDrift } from '@betterment/shared-components';

import { ManagedAccountDriftDocument } from './graphql/query.managedAccountsDrift.generated';

export const DriftInfo: React.FC<{ managedAccountId: string }> = ({ managedAccountId }) => {
  const { data, loading } = useGraphQLQuery(ManagedAccountDriftDocument, {
    variables: { id: managedAccountId },
  });

  if (!data && loading) {
    return (
      <Text color="text.weak" variant="text50">
        Drift: <ShimmerText textStyle="text50" css={{ display: 'inline-block', width: '80px' }} />
      </Text>
    );
  }

  if (!data) {
    return null;
  }

  const isAboveThreshold = data?.managedAccount.portfolio.drift.isAboveThreshold;
  return (
    <HStack css={{ display: 'inline-flex', alignItems: 'center' }}>
      <Text color="text.weak" variant="text50" css={{ paddingRight: 'space.50' }}>
        Drift:{' '}
      </Text>
      {isAboveThreshold ? (
        <Box css={{ display: 'flex', alignItems: 'center', gap: 'space.25' }}>
          <Icon size="xsmall" name="WarningFilled" color="icon.warning" />
          <Text as="span" color="text.warning" variant="text50">
            High ({formatDrift(data.managedAccount.portfolio.drift.current)}%)
          </Text>
        </Box>
      ) : (
        <Text as="span" color="text.weak" variant="text50">
          Normal ({formatDrift(data.managedAccount.portfolio.drift.current)}%)
        </Text>
      )}
    </HStack>
  );
};
